import { Suspense } from "react";
import { LeftPanel } from "./LeftPanel";
import { RightPanel } from "./RightPanel";

const AuthLayout = () => {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-[#F7F7F7] flex items-center justify-center">
          <div className="text-muted-foreground">Loading...</div>
        </div>
      }
    >
      <div className="min-h-screen bg-[#F7F7F7] flex">
        <LeftPanel />
        <RightPanel />
      </div>
    </Suspense>
  );
};

export default AuthLayout;
